import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'hmt-optimization-progress-dialog',
  templateUrl: './optimization-progress-dialog.component.html',
  standalone: false,
  styleUrls: ['./optimization-progress-dialog.component.scss']
})
export class OptimizationProgressDialogComponent {
  constructor(public dialogRef: MatDialogRef<OptimizationProgressDialogComponent>) {}
}

